/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_4_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next, make one change you can predict. For example, increase a single expense by 5 and check whether the relevant total increases by 5. If the workbook includes a budget-versus-actual comparison, identify which number represents the plan and which represents the expense. Changing the planned amount is a different action from changing the actual amount, even when the two columns use the same currency format.`)
};

const zh_gc_search_guides_gridcraft_online_sections_4_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接下来做一个能预测结果的修改，例如把一项支出增加 5，查看相关合计是否也增加 5。如果文件包含预算与实际支出对比，先确认哪列代表计划、哪列代表支出。即使两列使用相同货币格式，修改预算与修改实际支出也是不同操作。`)
};

/**
* | output |
* | --- |
* | "Next, make one change you can predict. For example, increase a single expense by 5 and check whether the relevant total increases by 5. If the workbook inclu..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_4_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_4_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_4_paragraphs_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_4_paragraphs_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_4_paragraphs_1 as "gc.search_guides.gridcraft_online.sections.4.paragraphs.1" }